import { LoggingLevel, LoggingType } from '../../Global/logging'

export class AALogger {
  private static logLevel: LoggingLevel = LoggingLevel.Default

  constructor() {
    document.AscendAwesome = document.AscendAwesome || {}
    document.AscendAwesome.LogManager = document.AscendAwesome.LogManager ?? {
      logWarning: this.logWarning.bind(this),
      logError: this.logError.bind(this),
      logDebug: this.logDebug.bind(this),
      logInfo: this.logInfo.bind(this),
    }
  }

  setLogLevel(level: LoggingLevel): void {
    AALogger.logLevel = level
    // You can add validation here if needed
    console.log(`[AA][AALogger] Log level set to ${level}`)
  }

  private logWarning(...args: any[]): void {
    this.log(LoggingType.Warning, ...args)
  }

  private logError(...args: any[]): void {
    this.log(LoggingType.Error, ...args)
  }

  private logDebug(...args: any[]): void {
    this.log(LoggingType.Debug, ...args)
  }

  private logInfo(...args: any[]): void {
    this.log(LoggingType.Info, ...args)
  }

  private log(logType: LoggingType, ...args: any[]): void {
    if (AALogger.logLevel === LoggingLevel.Off) {
      return
    }
    if (AALogger.logLevel === LoggingLevel.Default) {
      switch (logType) {
        case LoggingType.Error:
        case LoggingType.Warning:
        case LoggingType.Info:
          console.error(`[AA][${logType.toUpperCase()}]`, ...args)
          return
        default:
          break
      }
    }
    if (AALogger.logLevel === LoggingLevel.Verbose) {
      console.info(`[AA][${logType.toUpperCase()}]`, ...args)
    }
  }
}
